var $=jQuery.noConflict();
$(document).foundation();